import { composeClassNames } from "@faedev/editor-utils";
import Image from "next/image";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import { sHeroNFT } from "src/customs/sHeroNFT.module.scss";
import translate from "src/functions/translate";
import Small_chevron_right from "src/icons/Small-chevron-right";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sHeroBanner } from "src/styles/sHeroBanner.module.scss";

type Props = {
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
};

function HeroNFT({ className, style }: Props) {
  const { locale: lang, push } = useRouter();
  //const nftDate = new Date("2023-01-17T09:00:00");
  return (
    <div
      className={composeClassNames([
        sHeroBanner,
        sHeroNFT,
        className,
        "hero-banner",
        "hero-nft",
      ])}
      style={style}
    >
      <div className="hero-banner-image-wrapper">
        <div className="hero-banner-image-inner">
          <Image
            className="hero-banner-img"
            src="/images/heroe/hero-nft.jpg"
            alt="VIP program - NFT"
            layout="fill"
            objectFit="cover"
            priority
          />
        </div>
      </div>
      <Heading
        type="h2"
        align="left"
        className={composeClassNames([sGroupTitle, "hero-title"])}
        title={
          translate(`Vivido VIP membership`, lang) +
          " " +
          translate(`~ 1st yoga NFT in Czechia`, lang)
        }
      />
      <div className="hero-subtitle">
        <Paragraph size="xm">
          <Translate tKey="Do you have a favorite instructor? Great, meet them, get a significant discount on their course and take advantage of other great benefits." />
          <strong>
            <Translate tKey="The Vivido VIP program is only available to 48 of you. So hurry up!" />
          </strong>
        </Paragraph>
      </div>
      {/*<Countdown targetData={nftDate} />*/}
      <div className={composeClassNames([sButtons, "buttons"])}>
        <Button
          className={composeClassNames([sButton, "column", "btn-icon-after"])}
          onClick={() => push("/collection/vip-program")}
          size="lg"
          variant="primary"
        >
          <Translate tKey="Learn more about VIP Membership" />
          <Small_chevron_right />
        </Button>
      </div>
    </div>
  );
}

export default HeroNFT;
